/**
 * This function checks whether the flag's value is v1 or v2 and returns 
 * boolean value accordingly.
 * @param {*} flagValue The value of the flag that needs to be checked
 * @returns True if the flag's value is v1 or v2
 */
const checkFlagValueIsV1orV2 = (flagValue) => {
  return flagValue === "v1" || flagValue === "v2";
};

export { checkFlagValueIsV1orV2 };
